import { render, staticRenderFns } from "./AuthorInfo.vue?vue&type=template&id=7b7c5907&scoped=true"
import script from "./AuthorInfo.vue?vue&type=script&lang=js"
export * from "./AuthorInfo.vue?vue&type=script&lang=js"
import style0 from "./AuthorInfo.vue?vue&type=style&index=0&id=7b7c5907&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7c5907",
  null
  
)

export default component.exports